import React from 'react';
import { TextInput, required } from 'react-admin';

// Validate Saudi Mobile Number
export const validateSaudiMobile = (value) => {
  if (!value) return undefined;

  const mobile = value.toString().trim();

  // Check if exactly 10 digits
  if (!/^\d{10}$/.test(mobile)) {
    return 'رقم الجوال يجب أن يتكون من 10 أرقام';
  }

  // Check if starts with 05
  if (!mobile.startsWith('05')) {
    return 'رقم الجوال يجب أن يبدأ بـ 05';
  }

  return undefined;
};

export const SaudiMobileInput = ({ source_name, index, is_required, field_meta }) => {
  const validations = is_required ? [required(), validateSaudiMobile] : [validateSaudiMobile];

  return (
    <TextInput
      source={source_name}
      key={index}
      fullWidth
      validate={validations}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
        maxLength: 10,
      }}
      helperText="أدخل رقم الجوال السعودي (05xxxxxxxx)"
      placeholder="05xxxxxxxx"
    />
  );
};

export default SaudiMobileInput;
